import { render, staticRenderFns } from "./exchangeStoreInTable.vue?vue&type=template&id=5c1f40ca"
import script from "./exchangeStoreInTable.vue?vue&type=script&lang=js"
export * from "./exchangeStoreInTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports